<template>
  <div>
    <div class="p-2 bg-white border-2 border-b-0 rounded-t gap-2 flex items-center justify-between">
      <div>
        <v-btn @click="toggleSelectAll" elevation="0" class="mr-2">{{ $t('select_all') }}</v-btn>
        <v-btn
          @click="onPreApproveAll"
          :disabled="selected.length < 1"
          elevation="0"
          color="primary"
        >{{ $t('task.approve_all') }}</v-btn>
      </div>
      <div>
        <v-btn icon elevation="0" color="primary" @click="onInit()">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </div>
    </div>
    <template>
      <v-data-table
        show-select
        :headers="headers"
        :items="approveTasks"
        :loading="loading || isLoading"
        :items-per-page="50"
        class="border-2 data-table-resize"
        v-model="selected"
        @toggle-select-all="toggleSelectAll"
        item-key="objectId"
        :no-data-text="$t('market.no_list_of_renter_checkout')"
        :no-results-text="$t('no_matching_records_found')"
      >

        <template v-slot:header.contractCheckOut.customerData.name="{header}">
          <div class="text-nowrap-table text-center" style="min-width:150px">{{header.text}}</div>
        </template>
        <template v-slot:header.areas="{header}">
          <div class="text-nowrap-table text-center" style="min-width:150px">{{header.text}}</div>
        </template>

         <template v-slot:item.contractCheckOut.customerData.name="{ item }">
          <div class="text-truncate">
            {{ item.contractCheckOut.customerData.name }}
          </div>
        </template>

        <template v-slot:item.areas="{ item }">
          <template v-if="item.contractCheckOut.areas && item.contractCheckOut.areas.length">
            <div class="text-truncate">
              {{ item.contractCheckOut.areas.map(d => d.name).join(',') }}
            </div>
          </template>
        </template>
        <template v-slot:item.leaveDate="{ item }">
          <template v-if="item.contractCheckOut.checkOutDate">
            {{ $moment(item.contractCheckOut.checkOutDate).format('DD-MM-YYYY') }}
          </template>
        </template>
        <template v-slot:item.status="{ item }">
          <span :class="item.statusColor + ' px-3 py-1 rounded-full '">
            {{ item.statusString }}
          </span>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="flex justify-end">
            <v-btn
              color="grey lighten-4"
              elevation="0"
              rounded
              small
              @click="onClickEdit(item)"
            >{{ $t('detail') }}</v-btn>
          </div>
        </template>
      </v-data-table>
    </template>
    <template>
      <approve
        v-if="isApprove"
        v-model="isApprove"
        :approveId="approveTask.objectId"
        :contractCheckOutId="approveTask.contractCheckOut.objectId"
        :isUpdate="true"
        @onApproveTaskEvent="onInit"
        @onEditContractCheckOut="editContractCheckOut"
      ></approve>
      <!-- <CheckoutDialog
        v-model="isContractCheckOutDialog"
        :contractCheckOutId="isContractCheckOutDialog ? approveTask.contractCheckOut.objectId : ''"
        method='edit'
      /> -->
    </template>
    <ConfirmDialog
      :loading="isLoading"
      v-model="isConfirm"
      :title="`${$t('task.approve')}`"
      :text="`${$t('task.you_want_to_approve_setting', { count: selected.length })}`"
      :isNote="false"
      :textBtnOk="$t('confirm')"
      :textBtnCancel="$t('cancel')"
      type="success"
      @onOk="approveAll" />
  </div>
</template>


<script>
import Approve from "./Approve.vue";
import ConfirmDialog from "./ConfirmDialog.component.vue";
export default {
  components: { Approve, ConfirmDialog },
  data() {
    return {
      isInterest: false,
      interestId: null,
      approveId: null,
      isConfirm: false,
      isApprove: false,
      approveTask: null,
      isContractCheckOutDialog: false,
      headers: [],
      items: [],
      selected: [],
      isLoading: false
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.headers = [
        {
          text: this.$t('contract.contract_number_only'),
          align: "center",
          sortable: false,
          value: "contractCheckOut.contract.contractId"
        },
        {
          text: this.$t('contract.contractor_name'),
          align: "center hd-resize text-truncate",
          sortable: false,
          value: "contractCheckOut.customerData.name",
          width: '1%',
        },
        {
          text: this.$t('area.space'),
          align: "center hd-resize text-truncate",
          sortable: false,
          value: "areas",
          width: '1%',
        },
        {
          align: "center",
          value: "leaveDate",
          text: this.$t('area.checkout_date')
        },
        {
          align: "center",
          value: "createdAtDateFormat",
          text: this.$t('created_at')
        },
        {
          align: "center",
          value: "createdByFullName",
          text: this.$t('created_by')
        },
        {
          align: "center",
          value: "status",
          text: this.$t('status')
        },
        {
          text: "",
          align: "left",
          sortable: false,
          value: "actions"
        }
    ];
  },
  computed: {
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    },
    marketId() {
      return this.$route.params.marketId;
    },
    marketName() {
      return this.$store.getters["markets/getMarketName"];
    },
    approveTasks() {
      return this.$store.getters["approveTask/getByType"]('contract_check_out');
    }
  },
  mounted() {
    //   this.init();
  },
  methods: {
    onPreApproveAll() {
      this.isConfirm = true;
    },
    onClickEdit(approveTask) {
      this.approveTask = approveTask
      this.isApprove = true
      // this.isContractCheckOutDialog = true
    },
    
    onInit() {
      this.$emit("onInit");
    },
    afterUpdate(e) {
      this.isInterest = false;
      this.$emit("onInit", true);
      setTimeout(() => {
        this.isInterest = true;
      }, 500);
    },
    toggleSelectAll() {
      if (this.selected.length == this.approveTasks.length) {
        this.selected = [];
      } else {
        this.selected = this.approveTasks;
      }
    },
    editContractCheckOut(){
      this.isContractCheckOutDialog = true
    },
    async approveAll() {
      try {
        this.isLoading = true;
        const approve = this.selected.map(async item => {
          await this.$store.dispatch("approveTask/approveApproveTask", {
            id: item.objectId
          });
        });
        await Promise.all(approve);
        this.$toast.show({
          content: this.$t('task.approve_all_success'),
          color: "success"
        });
        this.isConfirm = false;
        this.$emit("onInit", true);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        this.isConfirm = false;
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        });
      }
    }
  }
};
</script>

<style scoped>
.data-table-resize::v-deep td.hd-resize{
  max-width: 150px;
}
.data-table-resize::v-deep td.hd-resize.area-name{
  max-width: 80px;
}
.data-table-resize::v-deep th.custom-sort {
  position: relative;
  .v-icon{
    position: absolute;
    right: 30px;
    top: 15px;
  }
}
</style>